import React, { useContext } from 'react';
import { Row, Col, Card, Stack, Image } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import 'assets/styles/common.scss';
import 'Pages/Doctor/DoctorDashboard/doctorDashboard.scss';
import { LocaleContext } from 'routes/Router';
import { FormattedMessage } from 'react-intl';
import HospitalIcon from 'assets/images/Dashboard/doctor-hospital.svg';
import VideoCallCameraIcon from 'assets/images/Dashboard/Video_Call.svg';
import ArrowRightIcon from 'assets/images/Dashboard/arrow-right-detail.svg';
import ClockIcon from 'assets/images/Dashboard/clock.svg';
import CalendarIcon from 'assets/images/Dashboard/calendar.svg';
import NextIcon from 'assets/images/Dashboard/nextIcon.svg';
import PrevIcon from 'assets/images/Dashboard/prevIcon.svg';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { useDispatch, useSelector } from 'react-redux';
import DefaultImage from 'assets/images/Dashboard/default-list.svg';
import moment from 'moment';
import { doctorAppointmentsUpcomingDetails } from 'routes/AppUrls';
import {
  basicDetailsValue,
  UPCOMING_ID,
} from 'store/BasicDetailValues/BasicDetailValuesAction';
import Shimmer from 'components/commom/Shimmer';

const DoctorUpcomingList = () => {
  const navigate = useNavigate();
  const { locale } = useContext(LocaleContext);
  const dispatch = useDispatch();

  const dashboardDetail = useSelector(
    (state) => state?.getDashboardReducer?.users?.data
  );

  const loading = useSelector((state) => state?.getDashboardReducer?.loading);

  const CustomNextArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{
          ...style,
        }}
        onClick={onClick}
      >
        <Image src={NextIcon} alt="icon" />
      </div>
    );
  };

  const CustomPrevArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{
          ...style,
        }}
        onClick={onClick}
      >
        <Image src={PrevIcon} alt="icon" />
      </div>
    );
  };

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 2.5,
    slidesToScroll: 1,
    nextArrow: <CustomNextArrow />,
    prevArrow: <CustomPrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const handleNavigateUpcoming = (id) => {
    navigate(doctorAppointmentsUpcomingDetails(locale));
    dispatch(basicDetailsValue(UPCOMING_ID, id));
  };

  return (
    <div>
      <Row className="mt-4 pt-1">
        <Col sm={12} md={12}>
          <div className="pt-28 fc-292D32 fs-20 family_outfit_semiBold_600">
            <FormattedMessage id="Upcoming Appointments" />
          </div>
        </Col>
      </Row>

      <Row className="mt-2 p-0 m-0 ">
        {dashboardDetail?.upcoming_appointments &&
        dashboardDetail?.upcoming_appointments.length > 0 ? (
          <Col sm={12} md={12} className="mt-2 p-0 m-0">
            <Slider
              {...settings}
              className={
                locale === 'en'
                  ? 'sliderDetailsEn single-item-slider'
                  : 'sliderDetailsAr single-item-slider'
              }
            >
              {dashboardDetail?.upcoming_appointments.map((item, index) => {
                return (
                  <div className="pr-3">
                    <Card className="p-12 subscription-card">
                      <Card.Body className="p-0">
                        <Card.Title>
                          <div className="flex m-0 p-0 justify-between">
                            <Stack
                              direction="horizontal"
                              gap={2}
                              className="items-center "
                            >
                              <Image
                                src={
                                  item?.patient?.profile_pic !== ''
                                    ? item?.patient?.profile_pic
                                    : DefaultImage
                                }
                                alt={'image'}
                                style={{
                                  width: '40px',
                                  height: '40px',
                                  borderRadius: '50%',
                                }}
                              />
                              <div className="fs-18 fc-292D32 lh-2268 family_outfit_semiBold_600 p-0 m-0">
                                {loading ? (
                                  <Shimmer width="250px" height="20px" />
                                ) : (
                                  item?.patient?.full_name
                                )}
                              </div>
                            </Stack>
                            <Image
                              src={
                                item?.consultation_type === 'Hospital Visit'
                                  ? HospitalIcon
                                  : VideoCallCameraIcon
                              }
                              alt={'image'}
                            />
                          </div>
                        </Card.Title>
                        <Card.Text>
                          <Stack
                            direction="horizontal"
                            gap={5}
                            className="items-center pt-04"
                          >
                            {loading ? (
                              <Shimmer width="100px" height="20px" />
                            ) : (
                              <Stack
                                direction="horizontal"
                                gap={2}
                                className="items-center"
                              >
                                <Image src={CalendarIcon} alt="icon" />
                                <div className="fs-16 fc-292D32 lh-201  family_outfit_medium_500">
                                  {moment(item?.appointment_date_time).format(
                                    'DD MMM YYYY'
                                  )}
                                </div>
                              </Stack>
                            )}

                            {loading ? (
                              <Shimmer width="100px" height="20px" />
                            ) : (
                              <Stack
                                direction="horizontal"
                                gap={2}
                                className="items-center"
                              >
                                <Image src={ClockIcon} alt="icon" />
                                <div className="fs-16 fc-292D32 lh-201  family_outfit_medium_500">
                                  {moment(item?.appointment_date_time).format(
                                    'hh:mmA'
                                  )}
                                </div>
                              </Stack>
                            )}
                          </Stack>

                          <Row className="pt-16">
                            <Col md={7}>
                              {loading ? (
                                <Shimmer width="250px" height="20px" />
                              ) : (
                                <div className="fs-14 lh-21 fc-998A7B family_outfit_regular_400">
                                  Booking ID:
                                  <span className="fc-3C3C3C">
                                    {item?.booking_id}
                                  </span>
                                </div>
                              )}
                            </Col>
                            <Col md={5} className="py-0 pl-0 flex justify-end">
                              <Stack
                                direction="horizontal"
                                gap={1}
                                className="flex items-center"
                              >
                                <div
                                  className="fs-16 fc-C56616 family_outfit_medium_500 cursor-pointer"
                                  onClick={() =>
                                    handleNavigateUpcoming(item?.id)
                                  }
                                >
                                  <FormattedMessage id="View Details" />
                                </div>
                                <Image
                                  src={ArrowRightIcon}
                                  alt="icon"
                                  className="cursor-pointer"
                                  onClick={() =>
                                    handleNavigateUpcoming(item?.id)
                                  }
                                />
                              </Stack>
                            </Col>
                          </Row>
                        </Card.Text>
                      </Card.Body>
                    </Card>
                  </div>
                );
              })}
            </Slider>
          </Col>
        ) : (
          <Col
            sm={12}
            md={12}
            className="border-1 bColor-EFE3D7 h-132 flex items-center justify-center"
          >
            <div className="text-center">
              <div className="fs-14 lh-201 fc-202224 family_outfit_regular_400 ">
                <FormattedMessage id="You haven’t created your schedule yet" />
              </div>
            </div>
          </Col>
        )}
      </Row>
    </div>
  );
};

export default DoctorUpcomingList;
